import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Logo from "components/Logo";
import LinkWrap from "components/LinkWrap";
import { StaticImage } from "gatsby-plugin-image";
import { flatListToHierarchical } from "js/utils.js";

export default function Footer() {
  return (
    <StaticQuery
      query={menuQuery}
      render={(data) => {
        const allMenus = data.allWpMenu.nodes;
        let menuFooter = allMenus.find((menu) => menu.slug === "footer")
          ?.menuItems.nodes;
        menuFooter = flatListToHierarchical(menuFooter);
        return (
          <footer className="footer">
            <div className="footer__wrap">
              <div className="footer__nav-wrap">
                <ul id="menu-footer-navigation" className="footer__nav">
                  {menuFooter.map((m0, i) => (
                    <M0 key={i} m0={m0} />
                  ))}
                  <li className="menu-item placeholder">
                    <LinkWrap to="">&nbsp;</LinkWrap>
                  </li>
                  <li className="menu-item placeholder">
                    <LinkWrap to="">&nbsp;</LinkWrap>
                  </li>

                  <div className="footer__nav__social">
                    <a className="footer__nav__social-link qr-wrap">
                      <img
                        className="footer__nav__social-svg"
                        src="/svg/wechat.svg"
                        alt="wechat"
                      />
                      <StaticImage
                        src="../images/qr-wechat.jpg"
                        alt=""
                        className="qr"
                      />
                    </a>

                    <a
                      href="https://www.facebook.com/analyticpartners/"
                      target="_blank"
                      className="footer__nav__social-link"
                    >
                      <img
                        className="footer__nav__social-svg"
                        src="/svg/facebook.svg"
                        alt="facebook"
                      />
                    </a>

                    <a
                      href="https://twitter.com/analyticglobal/"
                      target="_blank"
                      className="footer__nav__social-link"
                    >
                      <img
                        className="footer__nav__social-svg"
                        src="/svg/twitter.svg"
                        alt="twitter"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/analytic-partners/"
                      target="_blank"
                      className="footer__nav__social-link"
                    >
                      <img
                        className="footer__nav__social-svg"
                        src="/svg/linkedin.svg"
                        alt="linkedin"
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCicZEVdG6U1L-FNFvrkZBEg"
                      target="_blank"
                      className="footer__nav__social-link"
                    >
                      <img
                        className="footer__nav__social-svg"
                        src="/svg/youtube.svg"
                        alt="youtube"
                      />
                    </a>
                  </div>
                </ul>
              </div>

              <div className="footer__content-wrap">
                <div className="footer__logo">
                  <Logo className="footer__svg" />
                </div>
                <p className="footer__copyright">
                  <span>© 2021 勘讯企业咨询服务（上海）有限公司 </span>
                  {/* <span>
                    <a href='https://www.lanterndigital.com.cn' target='_blank'>
                      网站建设
                    </a>{' '}
                  </span> */}
                  <span>
                    <a href="https://beian.miit.gov.cn/" target="_blank">
                      沪ICP备19000357号-2 
                    </a>
                  </span>{' '}
                  <span>
                    <a 
                    style={{display: 'flex', alignItems: 'center', gap: '7px'}}
                    href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602008992" rel="noreferrer" target="_blank">
                      <img src="/images/备案图标.png" alt="备案图标" style={{width: '20px', height: '1auto'}} />
                      沪公网安备31010602008992号
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </footer>
        );
      }}
    />
  );
}

const M0 = ({ m0 }) => {
  let { path, title } = m0;
  path = path.replace("/wp", "");
  return (
    <li className="menu-item">
      <LinkWrap to={path}>{title}</LinkWrap>
    </li>
  );
};

const menuQuery = graphql`
  query {
    allWpMenu {
      nodes {
        id
        databaseId
        name
        slug
        menuItems {
          nodes {
            key: id
            parentId
            title: label
            path
          }
        }
      }
    }
  }
`;
